// Module
var code = "<employees-grid on-select=\"onEmployeeSelected($event)\"></employees-grid>\n";
// Exports
module.exports = code;